import cx from 'classnames';
import { motion } from 'framer-motion';
import _ from 'lodash';
import { HTMLAttributes, ReactNode } from 'react';
import css from './AnimatedView.module.scss';
import { IAnimatedViewContext, useAnimatedViewContext } from './context';
import { ViewExitDirection } from './types';

interface IAnimatedViewProps<T> {
  children: ReactNode | ((context: IAnimatedViewContext<T>) => ReactNode);
  className?: string;
  exitDirection: ViewExitDirection;
  name: T;
}

export const AnimatedViewContainer = ({
  className,
  ...rest
}: HTMLAttributes<HTMLDivElement>) => {
  return <div className={cx(css.container, className)} {...rest} />;
};

export const AnimatedView = <T,>({
  children,
  className,
  exitDirection,
  name,
}: IAnimatedViewProps<T>) => {
  const contextValues = useAnimatedViewContext<T>();

  const variants = {
    show: {
      x: 0,
      opacity: 1,
      transition: {
        duration: 0.3,
      },
    },
    hide: {
      x: exitDirection === ViewExitDirection.LEFT ? '-100%' : '100%',
      opacity: 0,
      transition: {
        duration: 0.3,
      },
    },
  };

  return (
    <motion.div
      className={cx(css.view, className)}
      animate={name === contextValues.current ? 'show' : 'hide'}
      initial={false}
      variants={variants}
    >
      {_.isFunction(children) ? children(contextValues) : children}
    </motion.div>
  );
};
